import { ModuleValueGeneral, SchemaModuleGeneral } from './module-general';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';

import * as rawJSONSchemaModuleCancerUterine from '../../schemas/module-cancer-uterine.json';

class ModuleValueCancerUterine extends ModuleValueGeneral {
  date_of_birth?: string;
  date_of_diagnosis?: string;
  date_treatment_started?: string;
  myometrial_invasion_depth_surgery?: number;
  myomterial_thickness_surgery?: number;
  myometrial_invasion_percent_surgery?: number;
  date_last_follow_up?: string;
  follow_up_duration?: number;
  follow_up_duration_compute?: boolean;

  cell_type_surgery?: string;
  stage_endometrial_surgery?: string[];
  stage_adenosarcoma_surgery?: string[];
  stage_mesenchymal_surgery?: string[];
  stage_calc_surgery?: string;

  cell_type_chemotherapy?: string;
  stage_endometrial_chemotherapy?: string[];
  stage_adenosarcoma_chemotherapy?: string[];
  stage_mesenchymal_chemotherapy?: string[];
  stage_calc_chemotherapy?: string;

  cell_type_radiotherapy?: string;
  stage_endometrial_radiotherapy?: string[];
  stage_adenosarcoma_radiotherapy?: string[];
  stage_mesenchymal_radiotherapy?: string[];
  stage_calc_radiotherapy?: string;

  cell_type_hormonal?: string;
  stage_endometrial_hormonal?: string[];
  stage_adenosarcoma_hormonal?: string[];
  stage_mesenchymal_hormonal?: string[];
  stage_calc_hormonal?: string;
}

type ModuleValueCancerUterineKey = keyof ModuleValueCancerUterine;

export class SchemaModuleCancerUterine extends SchemaModuleGeneral<ModuleValueCancerUterine> {
  schema: JSONSchema<ModuleValueCancerUterine>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleCancerUterine );
  }

  hook( form: FormComponent ) {
    super.hook( form );

    this.listenValue( [ 'myometrial_invasion_depth_surgery', 'myomterial_thickness_surgery' ], this.fieldHandlerCalculateMyometrialInvasion.bind( this ) );

    let cellStageFieldsSurgery: ModuleValueCancerUterineKey[] = [ 'stage_endometrial_surgery', 'stage_adenosarcoma_surgery', 'stage_mesenchymal_surgery' ];
    let cellStageFieldsChemotherapy: ModuleValueCancerUterineKey[] = [ 'stage_endometrial_chemotherapy', 'stage_adenosarcoma_chemotherapy', 'stage_mesenchymal_chemotherapy' ];
    let cellStageFieldsRadiotherapy: ModuleValueCancerUterineKey[] = [ 'stage_endometrial_radiotherapy', 'stage_adenosarcoma_radiotherapy', 'stage_mesenchymal_radiotherapy' ];
    let cellStageFieldsHormonal: ModuleValueCancerUterineKey[] = [ 'stage_endometrial_hormonal', 'stage_adenosarcoma_hormonal', 'stage_mesenchymal_hormonal' ];
    this.listenValue( cellStageFieldsSurgery, this.fieldHandlerCalculateCellStage( 'stage_calc_surgery' ).bind( this ) );
    this.listenValue( cellStageFieldsChemotherapy, this.fieldHandlerCalculateCellStage( 'stage_calc_chemotherapy' ).bind( this ) );
    this.listenValue( cellStageFieldsRadiotherapy, this.fieldHandlerCalculateCellStage( 'stage_calc_radiotherapy' ).bind( this ) );
    this.listenValue( cellStageFieldsHormonal, this.fieldHandlerCalculateCellStage( 'stage_calc_hormonal' ).bind( this ) );

    this.listenValue( 'follow_up_duration_compute', this.fieldHandlerFollowUpDurationCompute.bind( this ) );

    this.listenValue(
      [ 'date_last_follow_up', 'date_treatment_started' ],
      this.fieldHandlerCalculateFollowUpDuration.bind( this )
    );
  }

  fieldHandlerCalculateFollowUpDuration( followUpDate: string, startDate: string ) {
    if ( !this.getValue( 'follow_up_duration_compute' ) ) return;
    this.updateValue( 'follow_up_duration', this.diffInMonths( followUpDate, startDate, 30.5 ) );
  }

  fieldHandlerFollowUpDurationCompute( compute: boolean ) {
    if ( typeof compute === 'undefined' || compute === null ) return;
    this.schema.properties[ 'follow_up_duration' ].readOnly = compute;

    if ( compute ) {
      this.fieldHandlerCalculateFollowUpDuration(
        this.getValue( 'date_last_follow_up' ),
        this.getValue( 'date_treatment_started' ),
      );
    }
  }

  setupValidators() {
    super.setupValidators();

    this.validatorDateComparison( 'date_of_birth', 'date_of_diagnosis', '<' );
    this.validatorDateComparison( 'date_of_diagnosis', 'date_last_follow_up', '<' );
    this.validatorValueComparison( 'myometrial_invasion_depth_surgery', 'myomterial_thickness_surgery', '<=' );

    this.validatorDate( 'date_of_birth', ( new Date() ), '<=' , v => new Date( v as any ));
    this.validatorDate( 'date_of_diagnosis', ( new Date() ), '<=' , v => new Date( v as any ));
  }

  fieldHandlerCalculateMyometrialInvasion( depth: number, thickness: number ) {
    let percent = null;

    if ( depth !== null && thickness !== null && !isNaN( depth ) && !isNaN( thickness ) && thickness !== 0 ) {
      percent = Math.floor( ( depth / thickness ) * 100 );
    }

    if ( isNaN( percent ) ) {
      percent = null;
    }

    this.updateValue( 'myometrial_invasion_percent_surgery', percent );
  }

  fieldHandlerCalculateCellStage( propertyNameCellStage: ModuleValueCancerUterineKey ) {
    return ( endometrial: string[], adenosarcoma: string[], mesenchymal: string[] ) => {
      let maxStage: string = [
        ...( endometrial || [] ),
        ...( adenosarcoma || [] ),
        ...( mesenchymal || [] ),
      ]
        .map( v => ( v.match( /^stage_.+?(?=_)/ ) || [ null ] )[ 0 ] )
        .filter( v => !!v )
        .sort()
        .pop() || null;

      this.updateValue( propertyNameCellStage, maxStage );
    }
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-cancer-uterine.ts